import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c952250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "TransferPageBackground" }
const _hoisted_2 = { id: "transferInfo" }
const _hoisted_3 = { id: "leftMenuContainer" }
const _hoisted_4 = { id: "rowMenuContainer" }
const _hoisted_5 = { id: "collMenuContainer" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { id: "rightInfoContainer" }
const _hoisted_8 = { id: "header" }
const _hoisted_9 = { id: "headerMainContainer" }
const _hoisted_10 = { id: "headerLine1" }
const _hoisted_11 = { id: "majorName" }
const _hoisted_12 = { id: "headerLine2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "menuContainer" }, " 包含专业 ", -1))
const _hoisted_14 = { id: "mainBody" }

import IncludingMajor from './IncludingMajors.vue';
  import {ElMessage} from 'element-plus';
  import {ref, reactive, nextTick, computed, watch, inject} from 'vue';
  import {getMajor, getSubject, majorsGetLevelList} from "@/network/axios";
  import {useRouter, useRoute} from "vue-router";
  import {Search} from '@element-plus/icons-vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TransferPage',
  setup(__props) {

_useCssVars(_ctx => ({
  "22b4897f": (_unref(transitionTime)),
  "4e513659": (_unref(pointerEvents))
}))

  let refresh: any = inject('refresh');
  let router = useRouter();
  let route = useRoute();

  //根据专业名称查询
  let majorName =ref('');

  // let inputSearchButtonClick =()=>{
  //   console.log(majorName.value)
  // };


  //获取 inlcudingMajors 的元素
  let including = ref();

  //获取横向菜单栏的item
  let transverseMenu = ref([]);
  majorsGetLevelList('/majors/getLevelList').then((res)=>{
    if (res.data.code == 200){
      transverseMenu.value =res.data.data
    }else {
      ElMessage({
        type:'warning',
        message:res.data.message,
      })
    }
  })

  //给横向菜单栏改名字
  let changeTransverseMenu = (name:any)=>{
    if (name=='普通本科'){
      return '普本'
    }else if (name == '职业本科'){
      return '职本'
    }else if (name == '高职专科'){
      return '专科'
    }else {
      return name
    }

  }

  //纵向菜单栏的 dom
  let collMenuRef = ref();
  //纵向菜单栏 展开的index
  let collMenuOpenIndex = ref('');
  //路由 传过来的id
  let code = ref(route.params.id);
  let collegeCode = ref(route.params.collegeCode);

  if (code.value.length <= 3 || code.value.length == 5) {
    code.value = '0101';
    router.push('/TransferPage/0101');
    ElMessage({
      message: '查无此信息，页面自动跳转',
      type: 'warning',
      offset: 200,
    })
  } else if (code.value.length >= 6) {
    if (collegeCode.value){
      router.push('/MajorSituation/'+collegeCode.value +'/'+ code.value);
    }else {
      router.push('/MajorSituation/' + code.value);
    }
  }

  let transferPageInfo: any = reactive({
    //返回的  学历,专业类，国标代码
    level: '',
    subject: '',
    subjectCode: '',
    //返回的一级学科
    subjectInfo: [],
    //返回的 具体专业
    majorInfo: [],
  });

  //刚进页面 加载右侧的信息，再通过右侧信息的返回值，加载左侧下拉菜单
  getMajor('/majors/getMajors', {
    params: {
      majorGroup: code.value
    }
  }).then((res) => {
    // console.log(res.data);
    if (res.data.code == '200') {
      // console.log(res.data.data)
      transferPageInfo.level = res.data.data.level;
      transferPageInfo.subject = res.data.data.majorGroup;
      transferPageInfo.subjectCode = res.data.data.majorGroupCode;
      transferPageInfo.majorInfo = [];
      transferPageInfo.majorInfo = res.data.data.majors;
      getSubject('/majors/getMajorGroup', {
        params: {
          level: transferPageInfo.level
          // level: 1
        }
      }).then((res) => {
        // console.log(res.data);
        transferPageInfo.subjectInfo = [];
        for (const key in res.data.data) {
          transferPageInfo.subjectInfo.push(res.data.data[key]);
        }
        // console.log(transferPageInfo.subjectInfo)
      });
    }
    //如果传4位数，但是没有。就自动传 哲学：0101
    else if (res.data.data == null && code.value.length == 4) {
      getMajor('/majors/getMajors', {
        params: {
          majorGroup: '0101'
        }
      }).then((res) => {
        code.value = '0101';
        router.push('/TransferPage/0101');
        ElMessage({
          message: '查无此信息，页面自动跳转',
          type: 'warning',
          offset: 200,
        });
        transferPageInfo.level = res.data.data.level;
        transferPageInfo.subject = res.data.data.majorGroup;
        transferPageInfo.subjectCode = res.data.data.majorGroupCode;
        transferPageInfo.majorInfo = [];
        transferPageInfo.majorInfo = res.data.data.majors;
        getSubject('/majors/getMajorGroup', {
          params: {
            level: transferPageInfo.level
          }
        }).then((res) => {
          // console.log(res.data);
          transferPageInfo.subjectInfo = [];
          for (const key in res.data.data) {
            transferPageInfo.subjectInfo.push(res.data.data[key]);
          }
          // console.log(transferPageInfo.subjectInfo)
        });
      })
    }
  });



  //点击 职业本科，无法再点击 学科门类
  let pointerEvents = computed(() => {
    if (transferPageInfo.level == '2') {
      return 'none'
    } else{
      return 'auto'
    }
  });


  // 点击横向菜单栏，让纵向菜单栏的transition时间为0s。600ms后再将纵向菜单栏的transition时间设置为0.3s
  let transitionTime = ref('all 0.3s');
  watch(() => {
    return transferPageInfo.level
  }, () => {
    transitionTime.value = 'all 0s';
    setTimeout(() => {
      transitionTime.value = 'all 0.3s'
    }, 600)
  });

  //监听路由参数，刷新页面。解决点击浏览器自带 返回 按钮问题
  watch(() => {
    return route.params.id
  }, (newVal, oldVal) => {
    if (route.meta.title=='专业查询'){
      refresh.reload();
    }
  });

  //新打开一个 学科门类页面
  let goDisciplinePage = (category: any, type: any) => {
    window.open('/DisciplinePage/' + category + '/' + type)
    // console.log(id)
  };



  //点击 横向菜单栏 ：本科、专科、职业本科
  let rowMenuSelect = (key: any) => {
    if (transferPageInfo.level != key) {
      transferPageInfo.level = key;
      getSubject('/majors/getMajorGroup', {
        params: {
          level: key
        }
      }).then((res) => {
        // console.log(res.data);
        // console.log(code.value);
        transferPageInfo.subjectInfo = [];
        for (const key in res.data.data) {
          transferPageInfo.subjectInfo.push(res.data.data[key]);
        }
        nextTick(() => {
          collMenuRef.value.close(collMenuOpenIndex.value);
        })
      });
    }
  };

  rowMenuSelect(transferPageInfo.level)


  //纵向菜单栏的 open 回调
  let openCollMenu = (index: any) => {
    collMenuOpenIndex.value = index
  };


  //点击纵向菜单栏里的 item
  let clickMenuItem = (majorGroupCode: any) => {
    //触发 incldingMajors组件的 goScrollBar方法
    including.value.goScrollBar();
    router.push('/TransferPage/' + majorGroupCode);
    // getMajor('/majors/getMajors', {
    //   params: {
    //     majorGroup: majorGroupCode,
    //   }
    // }).then((res) => {
    //   // console.log(res.data);
    //   transferPageInfo.level = res.data.data.level;
    //   transferPageInfo.subject = res.data.data.majorGroup;
    //   transferPageInfo.subjectCode = res.data.data.majorGroupCode;
    //   transferPageInfo.majorInfo = [];
    //   transferPageInfo.majorInfo = res.data.data.majors;
    // })
  };

  let goFirstPage = () => {
    window.open('/', '_blank')
  }

  let goProfessionSearch = () => {
    window.open('/ProfessionSearch')
  };

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_menu, {
            "default-active": String(_unref(transferPageInfo).level),
            mode: "horizontal",
            onSelect: _unref(rowMenuSelect),
            ellipsis: false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transverseMenu), (item) => {
                return (_openBlock(), _createBlock(_component_el_menu_item, {
                  index: String(item.id)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(changeTransverseMenu)(item.name)), 1)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["default-active", "onSelect"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_scrollbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "unique-opened": true,
                class: "el-menu-vertical-demo",
                ref_key: "collMenuRef",
                ref: collMenuRef,
                onOpen: _unref(openCollMenu),
                "default-active": _unref(code)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transferPageInfo).subjectInfo, (item, i) => {
                    return (_openBlock(), _createBlock(_component_el_sub_menu, {
                      index: String(i)
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("a", {
                          id: "discipline",
                          onClick: _withModifiers(($event: any) => (_unref(goDisciplinePage)(item[0].subjectCategoryId,_unref(transferPageInfo).level)), ["stop"])
                        }, _toDisplayString(item[0].categories), 9, _hoisted_6)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item2, j) => {
                          return (_openBlock(), _createBlock(_component_el_menu_item, {
                            onClick: ($event: any) => (_unref(clickMenuItem)(item2.majorCategoryCode)),
                            index: String(item2.majorCategoryCode) 
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item2.majorCategory), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "index"]))
                        }), 256))
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["onOpen", "default-active"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString(_unref(transferPageInfo).subject), 1),
                _createVNode(_component_el_button, {
                  id: "collegeInquireBtn",
                  type: "primary",
                  onClick: _unref(goFirstPage)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("院校查询")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, "国标代码 " + _toDisplayString(_unref(transferPageInfo).subjectCode) + "(不可用于填报)", 1),
              _createVNode(_component_el_button, {
                class: "deepBlueBtn",
                type: "primary",
                onClick: _unref(goProfessionSearch)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("职业查询")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(IncludingMajor, {
            majorArray: _unref(transferPageInfo).majorInfo,
            ref_key: "including",
            ref: including
          }, null, 8, ["majorArray"])
        ])
      ])
    ])
  ]))
}
}

})